import classNames from 'clsx';
import React, { memo, MouseEvent, ReactElement, useCallback } from 'react';
import { noop } from 'reactApp/utils/helpers';

import { ITabMenuItem } from './TabMenu.types';
import styles from './TabMenuItem.css';

export const TabMenuItem = memo<ITabMenuItem>(
    ({ name, badge, active, value, bottomLine, mod, color, isMobile, changeHash = true, onClick = noop, ...props }): ReactElement => {
        const handleClick = useCallback(
            (event: MouseEvent) => {
                if (!changeHash) {
                    event.preventDefault();
                }

                if (!active) {
                    onClick(value);
                }
            },
            [active, changeHash, onClick, value]
        );

        return (
            <a
                data-qa-name={name}
                href={`#${value}`}
                onClick={handleClick}
                className={classNames({
                    [styles.item]: true,
                    [styles.item_bottomLine]: bottomLine,
                    [styles.item_mobile]: isMobile,
                    [styles[`item_${mod}`]]: !!mod,
                    [styles[`item_color_${color}`]]: !!color,
                    [styles.active]: active,
                })}
            >
                <div className={styles.name}>{name}</div>
                {badge && <span className={styles.badge}>{badge}</span>}
            </a>
        );
    }
);

TabMenuItem.displayName = 'TabMenuItem';
